import $ from 'jquery';

export default function edvBlockCounter(counterContainerClass) {
    let containers = $(counterContainerClass).toArray();
    // Current index container
    let currentIndex = 0;

    function checkAndStartCountdown() {
        // If all counter are completed
        if (currentIndex >= containers.length) return;

        let container = $(containers[currentIndex]);
        if (isElementInViewport(container) && !container.data('counted')) {
            startCountdown(container);
        }
    }

    function isElementInViewport(el) {
        let rect = el[0].getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }

    function startCountdown(container) {
        // Set current counter as counted
        container.data('counted', true);
        let counterElements = container.find('.counter-module__item-0, .counter-module__item-1');

        counterElements.each(function () {
            let counterElement = $(this);
            let finalValue = parseFloat(counterElement.find('.counter-item-number').text());
            let currentValue = 0;
            let intervalTime = 50;
            let increment = 1;
            let isDecimal = finalValue % 1 !== 0;

            counterElement.find('.counter-item-number').text(isDecimal ? currentValue.toFixed(2) : currentValue);

            let interval = setInterval(() => {
                if (currentValue < finalValue) {
                    let distanceToFinal = finalValue - currentValue;
                    increment = finalValue > 1000 ? Math.min(Math.ceil(distanceToFinal / 5), distanceToFinal) :
                        finalValue > 50 ? Math.min(Math.ceil(distanceToFinal / 20), distanceToFinal) :
                            Math.min(Math.ceil(distanceToFinal / 30), distanceToFinal);
                    currentValue += increment;
                    counterElement.find('.counter-item-number').text(isDecimal ? currentValue.toFixed(2) : Math.round(currentValue));
                } else {
                    clearInterval(interval);

                    counterElement.find('.counter-item-number').text(isDecimal ? finalValue.toFixed(2) : Math.round(finalValue));
                    if (counterElements.index(counterElement) === counterElements.length - 1) {
                        // Count next container
                        currentIndex++;
                        // Start next counter
                        checkAndStartCountdown();
                    }
                }
            }, intervalTime);
        });
    }

    $(window).on('scroll', checkAndStartCountdown);
    checkAndStartCountdown();
}
